var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"delayed-animated-number",class:{ blurred: _vm.blurred }},[_c('animated-number',{attrs:{"value":_vm.animatedValue,"formatter":_vm.format}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }